import React from 'react';
import ExternalPage from '../views/ExternalPage';
export default function Terms() {
    return React.createElement(ExternalPage, { title: "terms" });
}
